import { CopyIcon, CurecallTextButton, CurecallTooltip } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { AdminOnlyBadge } from 'src/components/admin-only-badge.component'
import { useSession } from 'src/providers/auth.provider'
import { useNotification } from 'src/providers/notification.provider'
import { useChatbotFlow } from './chatbot.provider'
import { convertNodesToApiFormat } from './chatbot-api.helper'

export function ChatbotCopyButton() {
  const { t } = useTranslation()
  const { currentUser } = useSession()
  const { notify } = useNotification()
  const { nodes, edges } = useChatbotFlow()

  if (!currentUser?.isAdmin) return null

  const handleCopy = async () => {
    const apiNodes = convertNodesToApiFormat(nodes, edges)
    await navigator.clipboard.writeText(JSON.stringify(apiNodes, null, 2))
    notify({
      title: t('common.actions.success'),
      message: t('pages.configuration.followups.chatbot.copy.success'),
      appearance: 'SUCCESS',
    })
  }

  return (
    <CurecallTooltip
      content={t('pages.configuration.followups.chatbot.copy.button')}
      tooltipPosition="bottom"
    >
      <div className="c-flex c-items-center c-gap-1">
        <AdminOnlyBadge variant="default" />
        <CurecallTextButton
          type="button"
          iconLeft={<CopyIcon className="c-h-4" />}
          onClick={handleCopy}
          className="c-text-sm c-w-max"
        >
          {null}
        </CurecallTextButton>
      </div>
    </CurecallTooltip>
  )
}
